import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'clients/';

class StatService {
    getClientStats(clientId, days = 7) {
        return axios.get(API_URL + clientId + '/stats', {
            headers: authHeader(),
            params: {
                days
            }
        });
    }
}

export default new StatService();